import React from 'react';

function CurrencyPriceList({ currencyPrices }) {
  return (
    <ul>
      {currencyPrices.map((item) => (
        <li>
          {`${item.currency}: ${item.price}`}
        </li>
      ))}
    </ul>
  );
}

export default CurrencyPriceList;
